var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "products__item",
      class: {
        "products__item--special": _vm.product.special,
        "products__item--limited": _vm.stock > 0,
        "products__item--exclusive": _vm.product.isCustomerExclusive
      }
    },
    [
      _vm.showProductSchema
        ? _c("script", {
            attrs: { type: "application/ld+json" },
            domProps: { innerHTML: _vm._s(_vm.productSchemaJsonLd) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.productLabel
        ? _c("img", {
            staticClass: "products__item-label",
            attrs: { src: _vm.productLabel, loading: "lazy" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.product.special
        ? _c(
            "a",
            {
              staticClass: "products__item-large-image",
              class: {
                "products__item-large-image--exclusive":
                  _vm.product.isCustomerExclusive
              },
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onClick.apply(null, arguments)
                }
              }
            },
            [
              _c("img", {
                ref: "largeImage",
                staticClass: "products__item-large-image-element",
                attrs: {
                  "data-object-fit": "",
                  src:
                    _vm.product.imageSpecial ||
                    _vm.product.imageMood ||
                    _vm.product.image,
                  alt: _vm.product.name,
                  loading: "lazy"
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.product.special && _vm.product.isCustomerExclusive
        ? _c("div", {
            staticClass: "products__item-large-image-exclusive",
            domProps: {
              innerHTML: _vm._s(_vm.$t("shoplist.product.customerExclusive"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "products__item-container" }, [
        !_vm.product.special
          ? _c(
              "a",
              {
                staticClass: "products__item-image",
                class: {
                  "products__item-image--exclusive":
                    _vm.product.isCustomerExclusive
                },
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onClick.apply(null, arguments)
                  }
                }
              },
              [
                _c("figure", { staticClass: "products__item-image-wrapper" }, [
                  _c("img", {
                    staticClass: "products__item-image-element",
                    class: {
                      "products__item-image-element--wide":
                        _vm.product.imageMood && !_vm.imageError
                    },
                    attrs: {
                      src: _vm.product.imageMood || _vm.product.image,
                      alt: _vm.product.name,
                      loading: "lazy"
                    },
                    on: { error: _vm.onImageError }
                  })
                ]),
                _vm._v(" "),
                _vm.product.isCustomerExclusive
                  ? _c("div", {
                      staticClass: "products__item-image-exclusive",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("shoplist.product.customerExclusive")
                        )
                      }
                    })
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "products__item-content" },
          [
            _c("div", { staticClass: "products__item-name" }, [
              _c("a", {
                attrs: { href: "javascript:void(0)" },
                domProps: { innerHTML: _vm._s(_vm.product.name) },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onClick.apply(null, arguments)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "products__item-desc",
              domProps: {
                innerHTML: _vm._s(
                  _vm.product.shortDescription || _vm.product.description
                )
              }
            }),
            _vm._v(" "),
            _vm.hasFeature("FEATURE_LIMITEDSTOCK") && _vm.stock > 0
              ? _c("div", {
                  staticClass: "products__item-limited",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("shoplist.product.limitedStock"))
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.product.variants.length > 1
              ? _c("div", { staticClass: "products__item-variants" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedVariant,
                          expression: "selectedVariant"
                        }
                      ],
                      staticClass: "products__item-variants-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedVariant = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.availableVariants, function(variant, index) {
                      return _c("option", {
                        key: variant.code,
                        domProps: {
                          value: index,
                          innerHTML: _vm._s(variant.name)
                        }
                      })
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.price || !_vm.product.isConfigurable || _vm.priceReduction
              ? _c(
                  "div",
                  { staticClass: "products__item-price" },
                  [
                    _vm.originalPrice
                      ? _c("strike", {
                          staticClass: "products__item-price-old",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                _vm.originalPrice,
                                "short"
                              )
                            )
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "products__item-price-current",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$options.filters.fwgpricecent(_vm.price, "short")
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.co2Compensation
                      ? _c("div", {
                          staticClass: "products__item-price-co2",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("shoplist.product.co2Compensation", {
                                amount: _vm.$options.filters.fwgpricecent(
                                  _vm.co2Compensation,
                                  "short"
                                )
                              })
                            )
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.priceReduction
              ? _c("div", {
                  staticClass: "products__item-price-reduction",
                  domProps: { innerHTML: _vm._s(_vm.priceReduction) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.hasBasket && !_vm.publicMode && !_vm.menuMode && !_vm.disabled
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "products__item-cart",
                      class: {
                        "products__item-cart--editable": _vm.product.isEditable
                      }
                    },
                    [
                      _c("div", {
                        ref: "message",
                        staticClass: "products__item-cart-message",
                        class: {
                          "products__item-cart-message--added": _vm.addedToCart
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("shoplist.product.successCart")
                          )
                        },
                        on: { click: _vm.onCloseMessage }
                      }),
                      _vm._v(" "),
                      !_vm.product.isEditable
                        ? _c("QuantityCounter", {
                            attrs: {
                              quantity: _vm.quantity,
                              "base-class": "products__item-quantity"
                            },
                            on: {
                              sub: function($event) {
                                return _vm.onSub()
                              },
                              add: function($event) {
                                return _vm.onAdd()
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.product.isConfigurable
                        ? _c("Button", {
                            staticClass: "products__item-configure-button",
                            attrs: {
                              level: "outline",
                              type: "button",
                              text: _vm.$t("shoplist.product.configButton"),
                              disabled: _vm.locked,
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.onConfig()
                              }
                            }
                          })
                        : _c(
                            "button",
                            {
                              staticClass: "products__item-cart-button",
                              attrs: { disabled: _vm.locked },
                              on: {
                                click: function($event) {
                                  return _vm.onCart()
                                }
                              }
                            },
                            [_c("SVGBag")],
                            1
                          )
                    ],
                    1
                  )
                ]
              : !_vm.menuMode && !_vm.disabled
              ? [
                  _c(
                    "div",
                    { staticClass: "products__item-cart" },
                    [
                      _c("Button", {
                        staticClass: "products__item-public-button",
                        attrs: {
                          level: "outline",
                          type: "button",
                          text: _vm.$t("shoplist.product.startOrder"),
                          small: ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.$emit("orderbox")
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }